import { render, staticRenderFns } from "./Oddeven.vue?vue&type=template&id=3ef584c7&scoped=true"
import script from "./Oddeven.vue?vue&type=script&lang=js"
export * from "./Oddeven.vue?vue&type=script&lang=js"
import style0 from "./Oddeven.vue?vue&type=style&index=0&id=3ef584c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef584c7",
  null
  
)

export default component.exports